import mongoose, { Schema, Model } from 'mongoose';
import { IChat } from '../interfaces/chat.interface';

const ChatSchema = new Schema<IChat>(
    {
        participants: [
            {
                type: Schema.Types.ObjectId,
                ref: 'User',
                required: true,
            },
        ],
        createdBy: {
            type: Schema.Types.ObjectId,
            ref: 'User',
            required: true,
        },
        isDeleted: {
            type: Boolean,
            default: false,
        },
        deletedAt: {
            type: Date,
        },
    },
    {
        timestamps: { createdAt: 'created_at', updatedAt: 'updated_at' },
        versionKey: false,
    }
);

// ChatSchema.index({ participants: 1 }, { unique: true, partialFilterExpression: { isDeleted: false } });

ChatSchema.pre('save', async function (next) {
    const chat = this as IChat;
    try {
        chat.participants = chat.participants.sort()
        if (chat.participants.length !== 2) {
            throw new Error('Chat must have exactly two participants');
        }

        // Prevent LABOUR-to-LABOUR chats
        const users = await mongoose.model('User')
            .find({ _id: { $in: chat.participants } })
            .populate('roleId', 'name')
            .lean();
        const roles = users.map(u => (u.roleId as any).name.toLowerCase());
        if (roles.every(role => role === 'labour')) {
            throw new Error('LABOUR to LABOUR chats are not allowed');
        }

        next();
    } catch (error) {
        next(error);
    }
});

const Chat: Model<IChat> = mongoose.model<IChat>('Chat', ChatSchema);
export default Chat;